import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
export const initialize = createAction(`${reduxKey}.INITIALIZE`, (payload)=>payload);
export const setIsWriterDeviationFeatured = createAction(`${reduxKey}.SET_IS_FEATURED`, (payload)=>payload);
export const setIsWriterDeviationMature = createAction(`${reduxKey}.SET_IS_MATURE`, (payload)=>payload);
export const saveWriterDeviation = createAction(`${reduxKey}.SAVE`, (payload)=>payload);
export const saveWriterDeviationFailure = createAction(`${reduxKey}.SAVE.FAILURE`, (error)=>({
        error
    }));
export const saveWriterDeviationSuccess = createAction(`${reduxKey}.SAVE.SUCCESS`, (payload)=>payload);
export const publishWriterDeviation = createAction(`${reduxKey}.PUBLISH`, (payload)=>payload);
export const setIsRedirecting = createAction(`${reduxKey}.SET_IS_REDIRECTING`, (payload)=>payload);
export const resetWriterPopup = createAction(`${reduxKey}.RESET`, ()=>({}));
export const writerPopupClosed = createAction(`${reduxKey}.CLOSED`, ()=>({}));

//# sourceMappingURL=actions.js.map